<template>
    <div class="free_use_home">
        <div class="swiper-container swiper-banner">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in listData.start" :key="index">
                    <div class="free_user_home_title_banner" :class="{'home_title_long_banner':Object.prototype.toString.call(item.coupon) === '[object Object]'}">
                        <div class="home_title_head">
                            <div class="home_title_head_logo"><img src="@/assets/home/logo.png" alt=""></div>
                            <div class="home_title_head_time">
                                <p class="head_time_text">距离<span><b>活动结束</b></span>剩余</p>
                                <div class="head_time_countDown">
                                    <p>{{item.countDown.day}}<i></i></p>
                                    <p>天<i></i></p>
                                    <p>{{item.countDown.hour}}<i></i></p>
                                    <p>时<i></i></p>
                                    <p>{{item.countDown.minute}}<i></i></p>
                                    <p>分</p>
                                </div>
                            </div>
                        </div>
                        <div class="home_title_free">
                            <img src="@/assets/home/free.png" alt="">
                        </div>
                        <div class="home_free_food">
                            <div class="home_free_food_plex">
                                <span>{{item.try_title}}</span>
                            </div>
                        </div>
                        <div class="home_title_btn" @click="goDetails(item.id)">立即申请 ></div>
                        <div class="food_img" :class="{'food_img-note': item.try_stage === '第 27 期'}" :id="'index-banner-img-' + item.id" style="">
                            <img style="width:100%" :src="item.banner_pic"
                                 alt="">
                        </div>
                        <!--<div style="width: 100%">
                            <img v-if="Object.prototype.toString.call(item.coupon) === '[object Object]'" style="width: 100%" src="@/assets/home/product-bg-long.png" alt="">
                            <img v-else style="width: 100%" src="@/assets/home/product-bg.png" alt="">
                        </div>-->
                        <div class="coupon" v-if="Object.prototype.toString.call(item.coupon) === '[object Object]'">
                            <p class="coupon-infor">申请试用还可获得{{item.coupon.coupon_title}}</p>
                            <img class="coupon-img" :src="item.coupon.coupon_image" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="procedure" style="width:100%;border-top: 1px solid #ccbaa3;border-bottom: 1px solid #ccbaa3;"><img style="width:100%" src="@/assets/home/liucheng.png" alt=""></div>
        <div class="free_user_home_main_recent">
            <div class="free_user_home_main_recent-bg"></div>
            <div class="recent_title">
                <img src="@/assets/home/biaoti.png" alt="">
            </div>
            <div class="swiper-container-box">
                <div class="swiper-container swiper-recent" style="padding-bottom: .52rem;">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(wait,waitIndex) in listData.wait" :key="waitIndex">
                            <div class="recent_main_item" v-for="(waitItem, waitItemIndex) in wait"
                                 :key="waitItemIndex">
                                <div class="recent_main_item_image">
                                    <div class="is-member" v-if="waitItem.is_member === '1'">
                                        <img class="is-member-img" src="@/assets/is-member.png" alt=""/>
                                    </div>
                                    <img @click="goDetails(waitItem.id)" :src="waitItem.try_pic" alt="">
                                    <span class="recent_main_item_icon">{{waitItem.try_stage}}</span>
                                </div>
                                <div class="recent_main_item_introduce">
                                    <div class="introduce_title">{{waitItem.try_title}}</div>
                                    <div class="introduce_num">产品数量：{{waitItem.total}}</div>
                                    <div class="introduce_num">活动开始时间：{{waitItem.date_begin}}</div>
                                    <div class="main-one-button">
                                        <div class="introduce_details">
                                            <p class="goDetails" @click="goDetails(waitItem.id)">查看详情></p>
                                        </div>
                                        <a class="introduce_details" :href="waitItem.buy_url?waitItem.buy_url:'###'">
                                            <p class="goDetails white">一键购买同款></p>
                                        </a>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="listData.wait && listData.wait.length > 1" class="swiper-pagination" slot="pagination"
                         style="bottom: 4px;"></div>
                </div>
            </div>
            <!--服务试用BEGIN-->
            <div class="recent_title fuwu service-try" v-if="listData.service && listData.service.length > 0">
                <img src="@/assets/home/fuwushiyong.png" alt="">
            </div>
            <div style="padding: 0 .45rem" v-if="listData.service && listData.service.length > 0">
                <div class="swiper-container swiper-recent1" style="padding-bottom: .52rem;">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(wait1,waitIndex1) in listData.service" :key="waitIndex1">
                            <div class="recent_main_item" v-for="(waitItem1, waitItemIndex1) in wait1"
                                 :key="waitItemIndex1">
                                <div class="recent_main_item_image" :class="{'list-img-full-cover': waitItem1.id === '1126', 'list-img-center': waitItem1.try_stage === '第2期'  }">
                                    <div class="is-member" v-if="waitItem1.is_member === '1'">
                                        <img class="is-member-img" src="@/assets/is-member.png" alt=""/>
                                    </div>
                                    <img @click="goDetails(waitItem1.id)" :src="waitItem1.try_pic" alt="">
                                    <span class="recent_main_item_icon wangqi">{{waitItem1.try_stage}}</span>
                                </div>
                                <div class="recent_main_item_introduce">
                                    <div class="introduce_title wangqi">{{waitItem1.try_title}}</div>
                                    <div class="introduce_num wangqi">活动开始时间：{{waitItem1.date_begin}}</div>
                                    <div class="main-one-button">
                                        <a class="introduce_details wangqi" href="javascript: void(0);">
                                            <p class="goDetails white" @click="goDetails(waitItem1.id)">查看详情></p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="listData.service && listData.service.length > 1" class="swiper-pagination"
                         slot="pagination" style="bottom: 4px;"></div>
                </div>
            </div>
            <!--服务试用END-->

        </div>
        <div class="free_user_home_main_history">
            <div class="history_title">
                <div class="history_title_img">
                    <img src="@/assets/home/historytitle.png" alt="">
                </div>
            </div>
            <div class="history_cate">
                <div class="history_cate_item" :class="{active:active == cateIndex}"
                     @click="selectItem(cateItem,cateIndex)" v-for="(cateItem,cateIndex) in cateList" :key="cateIndex">
                    <span> {{cateItem.cate}}</span>
                </div>
            </div>
            <div class="history_main" v-if="historyList.length > 0">
                <div class="history_main_item" v-for="(historyItem,historyIndex) in historyList" :key="historyIndex">
                    <div class="product-info">
                        <div class="history_icon1">{{historyItem.try_stage}}</div>
                        <div class="foodImg" @click="goDetails(historyItem.id)"><img :src="historyItem.try_pic" alt="">
                        </div>
                        <p class="foodTitle">{{historyItem.try_title}}</p>
                        <div class="foodApply">共{{historyItem.total}}份{{historyItem.applytotal}}人申请</div>
                        <a class="foodApplyBtn" v-if="cate_id !== '6'" :href="historyItem.buy_url?historyItem.buy_url:'###'">一键购买同款></a>
                    </div>
                    <div class="product-report-box">
                        <!--只有一个报告-->
                        <report-content :item="historyItem.have_selected[0]" :itemid="historyItem.id"
                                        v-if="historyItem.have_selected.length == 1"></report-content>

                        <!--有多个报告-->
                        <div class="swiper-container"
                             v-if="historyItem.have_selected && historyItem.have_selected.length > 1"
                             :id="'swiper-'+historyItem.id">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(report, rIndex) in historyItem.have_selected"
                                     :key="rIndex">
                                    <report-content :item="report" :itemid="historyItem.id"
                                                    v-if="report"></report-content>
                                </div>
                            </div>
                            <div class="swiper-pagination" slot="pagination" style="bottom: -0.08rem * 0.75;"></div>
                            <div class="swiper-button-prev" v-if="historyItem.have_selected.length > 1"></div>
                            <div class="swiper-button-next" v-if="historyItem.have_selected.length > 1"></div>
                        </div>

                        <!--没有报告-->
                        <div v-if="!historyItem.have_selected.length" class="no-report">暂无内容</div>

                    </div>
                </div>
            </div>
            <div class="history_main no_food" v-else>
                暂无数据
            </div>
            <div v-show="historyList.length&&historyList.length==4&&(page*4)<pageCount" class="history_more_btn"
                 @click="getMore">
                点击查看更多>
            </div>
        </div>

    </div>
</template>

<script>
    import "../../node_modules/swiper/dist/css/swiper.css";
    import Swiper from "swiper";
    import ReportContent from "../components/ReportContent";
    import {mapState} from 'vuex';

    export default {
        name: 'page2',
        components: {ReportContent},
        data() {
            return {
                swiperBanner: null,
                historyList: [],
                page: 1,
                pageCount: 0,
                cate_id: 5,
                food_img: '',
                food_num: "",
                apply_num: "",
                apply_time: '',
                sub_time: '',
                detail_time: '',
                food: {
                    name: '',
                    val: ''
                },
                active: '',
                countDown: {
                    day: '',
                    hour: '',
                    minute: ''
                },
                end_time: 0,
                countDownTimer: null,
                listData: {},
                cateList: [],
                swiperGroup: {},
                hasCoupon: false,
                couponTitle: '',
                couponImg: '',
                defalutVVideoImg: require('@/assets/home/video-cover.png'),
                pageRecord: {
                    module:'eshop促销活动',
                    category1: '0元试用',
                    category2: '首页',
                    title: '0元试用'
                }
            }
        },
        methods: {
            getMore() {
                this.page++;
                this.getHistoryList()
            },
            goShop(url) {
                console.log(url)
                if (url) {
                    this.$router.push(url)
                }
            },
            getHistoryList(page, id) {
                let swiper = this.swiperGroup;
                for (let key in swiper) {
                    this.swiperGroup[key].destroy();
                    delete (this.swiperGroup[key]);
                }
                this.axios.get(`/campaigns-b/try/index.php?_c=home&_a=tryhistory&p=${this.page}&cate_id=${this.cate_id}`)
                    .then(res => {
                        this.historyList = res.data.data.list.map(item => {
                          item.have_selected.sort((a, b) => {
                            return Number(b.video_id) - Number(a.video_id);
                          })
                          return item;
                        });
                        this.pageCount = res.data.data.count;
                        this.initSwiper(res.data.data.list);
                    })
            },
            initSwiper(data) {
                data.map(item => {
                    if (item.have_selected && item.have_selected.length > 1) {
                        let mark = '#swiper-' + item.id;
                        this.$nextTick(() => {
                            this.swiperGroup[item.id] = new Swiper(mark, {
                                loop: false,
                                speed: 600,
                                slidesPerView: 'auto',
                                pagination: {
                                    el: '.swiper-pagination',
                                    type: 'fraction'
                                },
                                navigation: {
                                  nextEl: mark + " .swiper-button-next",
                                  prevEl: mark + " .swiper-button-prev",
                                },
                            });
                        });
                    }
                });
            },
            initSwiperBanner() {
                if (this.swiperBanner) return;
                this.swiperBanner = new Swiper('.swiper-container.swiper-banner', {
                    autoHeight: true,
                    spaceBetween: 0,
                    speed: 600,
                    pagination: {
                        el: '.swiper-banner .swiper-pagination',
                    },
                });
            },
            initSwiperRecent() {
                if (this.swiperRecent) return;
                this.swiperRecent = new Swiper('.swiper-container.swiper-recent', {
                    loop: false,
                    autoHeight: true,
                    spaceBetween: 0,
                    speed: 600,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                });
                if (this.swiperRecent1) return;
                this.swiperRecent1 = new Swiper('.swiper-container.swiper-recent1', {
                    loop: false,
                    autoHeight: true,
                    spaceBetween: 0,
                    speed: 600,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                });
            },
            apply(id) {
                this.$router.push({
                    path: '/detail/' + id
                }).catch(err => {
                    err
                })

            },
            selectItem(cateItem, cateIndex) {
                this.page = 1;
                this.cate_id = cateItem.id
                this.active = cateIndex;
                this.getHistoryList()
            },
            goDetails(id) {
                this.$router.push({
                    path: '/detail/' + id
                }).catch(err => {
                    err
                })
            },
            countDownTimeGuard(end_time) {
                let nowTime = new Date().getTime();
                let time = parseInt((end_time - nowTime) / 1000);
                if (time < 60) {
                    return {
                        day: 0,
                        hour: 0,
                        minute: 0,
                    };
                }
                return {
                    day: parseInt(time / (24 * 60 * 60)),
                    hour: parseInt((time / (60 * 60)) % 24),
                    minute: parseInt((time / 60) % 60),
                };
            },
            getCoupon(id) {
                this.axios.get('/campaigns-b/try/index.php?_c=detail&_a=coupon&tid=' + id).then((response) => {
                    console.log('getCoupon response', response);
                    if (response.data.code == 200 && response.data.data.coupon_title) {
                        console.log('response.data.data', response.data.data);
                        this.hasCoupon = true;
                        this.couponTitle = response.data.data.coupon_title;
                        this.couponImg = response.data.data.coupon_image;
                    }
                }).catch(function (error) { // 请求失败处理
                });
            },
        },
        filters: {},
        computed: {
            ...mapState([
                'init',
                'activityRule',
                'liked',
                'userName',
                'userPortrait',
                'newPrice',
                'applyState'
            ])
        },
        created() {
            this.axios.get('/campaigns-b/try/index.php?_c=home&_a=trycate').then(res => {
                this.cateList = res.data.data
                this.cate_id = res.data.data[0].id;

                this.getHistoryList();
            })
            this.gioPageAction(this.pageRecord);

            document.title = '首页';
            this.axios
                .get('/campaigns-b/try/index.php?_c=home&_a=config')
                .then((response) => {
                    var d = response.data.data;
                    this.bannerImg = d.site_ban_m;
                    this.stage = d.try_stage;

                    config.routerCallback(Object.assign({}, d, {
                        pageName: 'home',
                        banner: this.bannerImg,
                        debug: process.env.VUE_APP_FLAG !== "pro"
                    }));


                })
                .catch(function (error) {
                    console.log(error);
                });

            this.axios
                .get('/campaigns-b/try/index.php?_c=home&_a=trylist')
                .then((response) => {
                    // 本期试用
                    this.listData = response.data.data;
                    this.listData.start.forEach(item => {
                        let end_time = new Date(item.date_end.replace(/-/g, '\/')).getTime();
                        item.date_begin = item.date_begin.substring(0, 10);
                        item.countDown = this.countDownTimeGuard(end_time);
                    });
                    setInterval(() => {
                        this.listData.start.forEach((item, index) => {
                            let end_time = new Date(item.date_end.replace(/-/g, '\/')).getTime();
                            item.countDown = this.countDownTimeGuard(end_time);
                            this.$set(this.listData.start, index, item)
                        })
                    }, 60 * 1000);
                    this.$nextTick(() => {
                        this.initSwiperBanner();
                    });

                    // 近期试用
                    let result = [];
                    this.listData.wait.forEach(item => {
                        item.try_pic = item.try_pic;
                        item.date_begin = item.date_begin.substring(0, 10)
                    })
                    for (let i = 0, len = this.listData.wait.length; i < len; i += 3) {
                        result.push(this.listData.wait.slice(i, i + 3))
                    }
                    this.listData.wait = result;
                    let result1 = [];
                    this.listData.service.forEach(item => {
                        item.try_pic = item.try_pic;
                        item.date_begin = item.date_begin.substring(0, 10)
                    })
                    for (let i = 0, len = this.listData.service.length; i < len; i += 3) {
                        result1.push(this.listData.service.slice(i, i + 3))
                    }
                    this.listData.service = result1;
                    this.$nextTick(() => {
                        this.initSwiperRecent();
                        if(this.$route.query.scrollTo === 'module-serve') {
                            document.querySelector(".fuwu")?.scrollIntoView(true);
                        }
                    });

                    // 往期试用
                    this.listData.history.forEach(item => {
                        item.try_pic = this.dev + item.try_pic;
                        item.date_begin = item.date_begin.substring(0, 10)
                    })

                    let allTryList = [];
                    let nowTime = new Date().getTime();
                    allTryList = [...this.listData.history, ...this.listData.start, ...this.listData.wait];
                    allTryList.map(item => {
                        item.stage_index = Number(item.try_stage.replace(/[^0-9]/ig, ""));
                        item.startTime = new Date(item.date_begin.replace(/-/g, "/")).getTime();
                        item.endTime = new Date(item.date_end.replace(/-/g, "/")).getTime();
                        if (item.startTime > nowTime) {
                            item.applyState = 'start';
                        }

                        if (nowTime >= item.startTime) {
                            item.applyState = 'ing';
                        }

                        if (nowTime >= item.endTime) {
                            item.applyState = 'end';
                        }
                    });
                    allTryList = this.$tool.sortKey(allTryList, 'stage_index').reverse();
                    console.log('allTryList', allTryList);
                    this.$store.commit('setState', {allTryList});
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    }
</script>

<style scoped lang="scss">
    img {
        vertical-align: top;
    }

    .noBanner_btn {
        height: 0.5rem * 0.75;
        line-height: 0.5rem * 0.75;
        text-decoration: normal;
        margin-top: .1rem * 0.75;
        padding: 2px 16px;
        font-size: 12px;
        position: relative;
    }

    .free_use_home {
        display: flex;
        flex-direction: column;
        /* background: #0C73D8; */
        background: url('~@/assets/home/page-bg.jpg') repeat top center/contain;
        justify-content: center;
        align-items: center;
    }

    .free_user_home_title_banner {
      position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        height: 8.8rem;
        background: url('~@/assets/home/banner.png') top center/cover no-repeat;
        background-size: 100% 100%;
    }

    .home_title_long_banner{
        height: 9.3rem;
        background: url('~@/assets/home/banner-long.png') top center/cover no-repeat;
    }

    .home_free_food {
        display: flex;
        align-items: center;
        padding: 0 .3rem;
        margin: .3rem 0;
    }

    .home_title_free{
      width: 6.16rem;
      height: .8rem;
      img{
        width: 100%;
        height: 100%;
      }
    }

    .home_free_food_plex {
        display: flex;
        align-items: center;
        justify-content: center;
      text-align: center;
        margin-top: .15rem;
        font-size: .36rem;
        color: #e6dbcd;
        font-weight: bold;
    }

    .food_name {
        font-size: 0.5rem * 0.75;
        color: #fff;
        font-weight: bold;
        text-align: center;
    }

    .food_val {
        font-size: 0.45rem * 0.75;
        color: #db433d;
        font-weight: bold;
    }

    .home_title_timeLine {
        height: 1.2rem * 0.75;
        line-height: .6rem * 0.75;
        margin-top: .5rem * 0.75;
        width: 75%;
        /* background: rgba(256, 256, 256, 0.2); */
        border-radius: .3rem * 0.75;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
    }

    .timeLine_line > img {
        width: .2rem * 0.75;
    }

    .home_title_head {
        width: 90%;
        height: 1.05rem * 0.75;
        margin: 0.35rem auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .timeLine_line {
        justify-content: space-around !important;
        width: 90%;
        height: .02rem * 0.75;
        background: rgba(256, 256, 256, 0.3);
    }

    .timeLine_flex {
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
    }

    .home_title_food_detail {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .home_title_head_logo {
        width: 35%;
    }

    .home_title_head_logo img {
        width: 100%;
    }

    .home_title_head_time {
        width: 45%;
        height: 100%;
    }

    .head_time_countDown {
        display: flex;

        align-items: center;
        width: 100%;
        height: 20px;
        border: 1px solid #fff;
        border-radius: 6px;
    }

    .head_time_countDown > p {
        font-weight: bold;
        position: relative;
        line-height: 20px;
        font-size: 14px;
        text-align: center;
        flex: 1;
        color: #fff;
    }

    .head_time_countDown > p:nth-of-type(6) {
        border-right: none;
    }

    .head_time_countDown > p > i {
        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        height: 100%;
        background: url('~@/assets/home/dotted.png') top center/cover no-repeat;
        background-size: 100% 100%;
    }

    .head_time_text {
        text-align: center;
        letter-spacing: 3px;
        margin-bottom: .08rem;
        font-size: 0.3rem * 0.75;
        color: #fff;
        b{
            font-weight: bold;
        }
    }

    .head_time_text > span {
        color: #da1b13;
        font-size: calc(0.4rem * 0.75);
    }

    .home_title_btn {
        text-align: center;
        width: 2.2rem;
        height: .5rem;
        line-height: .5rem;
        background: url('~@/assets/home/newlijishenqing.png') top center/cover no-repeat;
        background-size: 100% 100%;
        position: relative;
        margin-top: .15rem;
        font-size: .3rem;
        color: #fff;
    }

    .food_img {
      width: 3.3rem;
      height: 3.3rem;
      margin: 0 auto;
      position: absolute;
      bottom: 1.4rem;
      pointer-events: none;
    }

    .food_img-note {
      width: 4.3rem;
      height: 4.3rem;
      top: -.75rem;
      pointer-events: none;
    }

    .coupon {
        margin-top: 1.3vw;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .coupon-infor {
        font-size: 3.2vw;
        font-weight: bold;
        color: #FFFFFF;
    }

    .coupon-img {
        width: 13.1vw;
        height: 13.1vw;
        margin-left: 1.5vw;
    }

    .free_user_home_main_recent {
        position: relative;
        z-index: 2;
        padding-bottom: 1.5rem * 0.75;
        width: 100%;
        margin-top: 0.75rem * 0.75;
        margin-right: 0.4rem * 0.75;
        margin-bottom: 0;
        margin-left: .4rem * 0.75;
        height: auto;
        background: url('~@/assets/home/home-main-jinqi4.png') no-repeat;
        background-size: 100% 100%;
    }

    .free_user_home_main_recent-bg {
        position: absolute;
        top: 50.3vw;
        left: 0;
        z-index: -1;
        width: 100%;
        height: calc(100% - 50.3vw - 55.25vw + 2vw);
        overflow: hidden;
        /*background: url('~@/assets/home/home-main-jinqi2.png') center ;*/
        background-size: 100%;
        margin-top: -1vw;
    }

    .recent_title {
        width: 46%;
        margin: 1.2rem auto 0.65rem * 0.75;
    }

    .recent_title.fuwu {
        padding: 0.46rem 0 0.46rem * 0.75;
        margin: 0 auto;
    }

    .history_title {
        width: 100%;
        height: 2.05rem * 0.75;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .history_title_img {
        width: 46%;
    }

    .history_title_img img {
        width: 100%;
    }

    .recent_title img {
        width: 100%;;
    }

    .recent_main_item {
        margin: 0 auto .1rem * 0.75;
        width: 100%;
        height: 3.8rem * 0.75;
        border: 1px solid #5a84d3;
        display: flex;
        align-items: center;
    }

    .recent_main_item_image {
        background: linear-gradient(rgb(255,255,255) 0%,rgb(199,225,255) 100%);
        margin-left: .2rem * 0.75;
        width: 2.88rem * 0.75;
        height: 2.96rem * 0.75;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 13px 0 rgba(0, 0, 0, .18);

      .is-member {
        position: absolute;
        left: 0;
        top: .4rem;

        .is-member-img {
          height: .5rem;
        }
      }
    }

    .recent_main_item_image > img {
        display: block;
        margin: 0 auto;
        width: 90%;
    }

    .list-img-full-cover{
      img{
        width: 2.16rem;
        height: 2.28rem;
        object-fit: cover;
      }
    }
    .list-img-center{
      img{
        position: relative;
        top: -.45rem;
      }
    }

    .recent_main_item_icon {
        display: block;
        padding-left: 4px;
        padding-right: 8px;
        padding-top: 2px;
        padding-bottom: 2px;
        text-align: center;
        font-size: 10px;
        color: #fff;
        background: url('~@/assets/home/qi.png') top center/cover no-repeat;
        background-size: 100%;
        position: absolute;
        left: 0;
        top: 0.9vw;
    }

    .recent_main_item_icon.wangqi {
        background: url('~@/assets/home/wangqi.png') top center/cover no-repeat;
    }

    .recent_main_item_introduce {
        width: 60%;
        height: 3.2rem * 0.75;
        margin-left: .2rem * 0.75;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .introduce_title {
        /* font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis; */
        font-weight: bold;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 25px;
        font-size: .24rem;
    }

    .introduce_title.wangqi {
        line-height: 1;
    }

    .introduce_num {
        color: #000;
        font-size: 12px;
        line-height: 25px;
    }

    .introduce_num.wangqi {
        line-height: 32px;
    }

    .introduce_start_time {
        margin-top: .1rem * 0.75;
        width: 48vw;
        height: 5.26vw;
        padding-left: 1.6vw;
        display: flex;
        align-items: center;
        font-size: 2.6vw;
        line-height: 2.6vw;
        color: #fff;
        background: url('~@/assets/home/timebanner.png') center center/cover no-repeat;
        background-size: 100% 100%;
    }

    .introduce_start_time .time1 {
        width: 24vw;
        font-size: 3.2vw;
        line-height: 3.2vw;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .introduce_start_time .time2 {
        width: 24vw;
        font-size: 3.2vw;
        line-height: 3.2vw;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .introduce_start_time_icon {
        width: 2.8vw;
        height: 2.8vw;
        min-width: 2.8vw;
        min-height: 2.8vw;
        /* margin-bottom: 1.8vw; */
        margin-right: 0.5vw;
        background: url('~@/assets/home/time.png') top center/cover no-repeat;
        background-size: 100% 100%;
    }

    .main-one-button {
        width: 98%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .introduce_details {
        margin-top: .2rem * 0.75;
        width: 50%;
        height: .5rem * 0.75;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url('~@/assets/home/chakananniu4.png') top center/cover no-repeat;
        background-size: 100% 100%;
    }

    .introduce_details.wangqi {
        margin-top: 0;
    }

    .introduce_details:last-child {
        width: 50%;
        background: url('~@/assets/home/chakananniu3.png') top center/cover no-repeat;
        background-size: 100% 100%;
    }

    .goDetails {
        color: #000;
        font-size: 12px;
        line-height: 12px;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    .goDetails.white {
        color: #fff;
    }

    .goDetails > span {
        margin-left: 3px;
        background: url('~@/assets/home/chakan.png') top center/cover no-repeat;
        background-size: 100%;
        width: 8px;
        height: 8px;
    }

    .free_user_home_main_history {
        position: relative;
        z-index: 2;
        margin: 30px .34rem 50px .34rem * 0.75;
        height: auto;
        padding-bottom: 10vw;
        background: url('~@/assets/home/home-main-newwangqi1.png') no-repeat;
        background-size: 100% 100%;
    }

    .free_user_home_main_history-bg {
        position: absolute;
        z-index: -1;
        top: 15.728vw;
        left: 0;
        width: 100%;
        height: calc(100% - 15.728vw - 10.216vw + 1vw);
        overflow-y: hidden;
        background: url('~@/assets/home/home-main-wangqi2.png') center;
        background-size: 100%;
        margin-top: -1vw;
    }

    /*.free_user_home_main_history-bg1 {*/
    /*    position: absolute;*/
    /*    z-index: -1;*/
    /*    bottom: 0;*/
    /*    left: 0;*/
    /*    width: 100%;*/
    /*    height: 11.216vw;*/
    /*    overflow-y: hidden;*/
    /*    background: url('~@/assets/home/home-main-wangqi3.png') 5px center no-repeat;*/
    /*    background-size: 98.2%;*/
    /*    margin-top: -1vw;*/
    /*}*/
    .history_cate {
        box-sizing: border-box;
        width: 96%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 0.25rem * 0.75;
    }

    .history_cate_item {
        box-sizing: border-box;
        width: 20%;
        height: 0.8rem * 0.75;
        margin-right: 2px;
        background-color: #fff;
        color: #203756;
        border: 1px solid #203756;
    }

    .history_cate_item > span {
        box-sizing: border-box;
        text-align: center;
        font-size: 2.6vw;
        line-height: 0.8rem * 0.75;
    }

    .history_cate_item > span {
        display: block;
        border-color: #fff;
        position: relative
    }

    .history_cate_item > span::after {
        content: '';
        width: 1px;
        height: 40%;
        border-right: 1px solid;
        border-color: #fff;
        position: absolute;
        right: 0;
        top: 25%;
    }

    .history_cate_item:nth-of-type(5) > span::after {
        display: none;
    }

    .active {
        background-color: #203756;
        color: #fff;
        /*background: url('~@/assets/home/checknote.png') top center/cover no-repeat;*/
        /*background-size: 100% 100%;*/
    }

    .active > span::after {
        display: none;
    }

    .history_main {
        width: 93vw;
        padding: 3.5vw .3rem * 0.75 2.8vw;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .history_main_item {
        width: 4.3rem * 0.75;
        height: 76.6vw;
        margin-bottom: 1.5vw;
        position: relative;
        box-shadow: 0 0 13px 0 rgba(0, 0, 0, .18);
    }

    .product-info {
        width: 4.3rem * 0.75;
        height: 47vw;
        padding: 1.5vw 1.5vw 0;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-image: linear-gradient(0deg, rgb(199, 225, 255) 0%, rgb(255, 255, 255) 69%);
    }

    .product-report-box {
        .swiper-pagination-fraction{
            bottom: .05rem;
            font-size: .22rem;
            color: #6e6e6e;
            ::v-deep .swiper-pagination-current{
                color: #0976f1;
            }
        }
    }

    .no-report {
        text-align: center;
        color: #ccc;
        padding-top: 10vw;
        font-size: .375rem;
    }

    .free_use_home .swiper-container {
        width: 100%;

        .swiper-wrapper {
            width: 100%;

            .swiper-slide {
                width: 100%;
            }
        }
    }

    .swiper-container-box{
        padding: 0 .45rem;
    }

    .history_main_item .swiper-container {
        width: 100%;
        height: 2.9rem * 0.75;
        overflow: hidden;
    }

    .history_main_item .swiper-container .swiper-slide {
        width: 100%;
        /* padding-left: 2.5vw;
        padding-right: 2.5vw; */
        height: 2.6rem * 0.75;
        display: inline-block;
    }

    .history_main_item .swiper-container ::v-deep .swiper-pagination-bullets{
        bottom: 0;
    }

    .history_main_item .swiper-container ::v-deep .swiper-pagination-bullet {
        background: #ccc;
        opacity: 1;
    }

    .history_main_item .swiper-container ::v-deep .swiper-pagination-bullet-active {
        background: #0076ce;
    }

    .history_main_item {
      .swiper-button-prev, .swiper-button-next {
        position: absolute;
        top: auto;
        bottom: 0;
        width: 20px;
        height: 20px;
        margin-top: 0;
        z-index: 10;
        cursor: pointer;
        background-size: 7px 15px;
        background-position: center;
        background-repeat: no-repeat;
      }
      .swiper-button-next {
        right: 30px;
      }
      .swiper-button-prev {
        left: 30px;
      }
    }

    .foodImg {
        height: 1.6rem;
        margin-bottom: .2rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .foodImg img {
        width: auto;
        height: auto;
        max-height: 100%;
        max-width: 100%;
    }

    .foodTitle {
        width: 100%;
        height: 8vw;
        font-size: 2.8vw;
        line-height: 3vw;
        color: #000000;
        text-align: center;
        font-weight: bold;

        /* overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis; */

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .foodApply {
        margin: 0.5vw 0 1.8vw;
        text-align: center;
        font-size: 2.4vw;
        color: #000000;
        line-height: 2.7vw;
    }

    .foodApplyBtn {
        width: 28vw;
        height: 4.6vw;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 4.6vw;
        color: #fff;
        font-size: 2.3vw;
        background: url('~@/assets/home/chakananniu3.png') top center/cover no-repeat;
        background-size: 100% 100%;
        position: relative;
    }

    .foodApplyBtn > img {
        width: 2.2vw;
        margin-left: 1.2vw;
    }


    .history_icon1 {
        z-index: 50;
        left: 0;
        top: 2.5vw;
        font-size: 10px;
        position: absolute;
        color: #fff;
        padding: 2px 8px 2px 4px;
        text-align: center;
        background: url('~@/assets/home/qi.png') top center/cover no-repeat;
        background-size: 100%;
    }

    .history_icon2 {
        right: 0;
        bottom: 21.1vw;
        font-size: 10px;
        width: auto;
        height: 4.1vw;
        padding: 0 0.5vw 0 1vw;
        position: absolute;
        color: #fff;
        font-size: 2.2vw;
        color: #FFFFFF;
        line-height: 4.1vw;
        background: url('~@/assets/home/red.png') top center/cover no-repeat;
        background-size: 100% 100%;
    }

    .history_more_btn {
        width: 38.4vw;
        height: 5.4vw;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        color: #0976f1;
        text-decoration: underline;
        font-size: .24rem;
    }

    .history_more_btn p {
        font-size: 3vw;
        color: #FFFFFF;
        line-height: 4.7vw;
    }

    .history_more_btn img {
        width: 3vw;
        margin-left: 3.3vw;
    }

    .no_food {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 93vw;
        height: 150.7vw;
        font-size: 2.3vw;
        color: #243a58;
        line-height: 4.4vw;
        letter-spacing: 0.5vw;
    }
</style>
